module.exports = __webpack_public_path__ + "static/media/capa_06.414b20bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/capa_06.jpg
// module id = 81
// module chunks = 0